class Quiz {

  constructor(max_questions_no) {
    this.max_questions_no     = max_questions_no;
    this.points_per_question  = 100;
    this.max_points           = (this.points_per_question * this.max_questions_no);
    this.current_points       = 0;
  }

  get_current_points(){
    return this.current_points;
  }

  calculate_score(){
    var score = Math.ceil(((this.current_points / this.max_points) * 100));
    return (score > 100 ? 100 : score) + ' %';
  }

  calculate_single_value(correct_value, current_value, cb){
    console.log(correct_value, current_value);
    var points = 0;
    if (correct_value <= current_value){
      points = Math.ceil( ((correct_value / current_value) * this.points_per_question) );
    }
    else{
       points = Math.ceil( ((current_value / correct_value) * this.points_per_question) );
    }
    this.current_points += points;
    return cb();
  }

  calculate_multi_values(correct_values, current_values, cb){
    var self    = this;
    var points  = 0;
    var correct_values_count = 0;
    var answers = ['answer_a','answer_b','answer_c'];
    jquery.each(answers, function(index, answer){
      if (correct_values[answer]){
        correct_values_count += 1;
      }
    });
    jquery.each(answers, function(index, answer){
      if (correct_values[answer] && current_values[answer]){
        points += (self.points_per_question / correct_values_count);
      }else if (! correct_values[answer] && current_values[answer]){
        points -= (self.points_per_question / correct_values_count);
      }
    })
    this.current_points += Math.ceil((points < 0 ? 0 : points));
    return cb();
  }

}
window.Quiz = Quiz;
